import { Component } from '@angular/core';
import { TransferHttpService } from '../../services/transfer-http/transfer-http.service';
import { AimsCommonTableHeader, AimsCommonTablePermissions, TableRowUpdate } from '@aims/common-components';
import { Observable } from 'rxjs';
import { MainGridService } from 'src/app/components/maingrid/main-grid.service';
import { Validators } from '@angular/forms';
import { AccCopas } from 'src/models';

@Component({
  selector: 'copas',
  templateUrl: './copas.component.html',
  providers: [MainGridService],
})
export class CopasComponent {

  constructor(private transferHttp: TransferHttpService,
    public mainGridService: MainGridService<any>) { }

  public copas: Observable<any> = this.mainGridService.getAll(
    'Common/GetCopas',
    'Common/SaveCopa');

  // AimsCommonTable setup
  tablePermissions: AimsCommonTablePermissions = {
    create: true,
    update: true,
    delete: false,
    export: false
  };
  header: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton', editable: false, filter: false },
    { key: 'copaNumber', label: 'COPA Number', type: 'string', editable: true, validatorOrOpts: [Validators.required, Validators.maxLength(50) ] },
    { key: 'copaDescription', label: 'COPA Description', type: 'string', editable: true, validatorOrOpts: [Validators.required, Validators.maxLength(100) ] },
    { key: 'projIdPrefix', label: 'Proj ID Prefix', type: 'string', editable: true, validatorOrOpts: [Validators.required, Validators.maxLength(14) ] },
    { key: 'laborTaskCode', label: 'Labor TC', type: 'string', editable: true, validatorOrOpts: [Validators.required, Validators.maxLength(9) ] },
    { key: 'travelLaborTaskCode', label: 'Travel TC', type: 'string', editable: true, validatorOrOpts: [Validators.required, Validators.maxLength(9) ] },
    { key: 'wxDelayLaborTaskCode', label: 'Wx Delay TC', type: 'string', editable: true, validatorOrOpts: [Validators.maxLength(9) ] },
    { key: 'travelPurchaseTaskCode', label: 'Travel Cost TC', type: 'string', editable: true, validatorOrOpts: [Validators.required, Validators.maxLength(9) ] },
    { key: 'materialPurchaseTaskCode', label: 'Material TC', type: 'string', editable: true, validatorOrOpts: [Validators.required, Validators.maxLength(9) ] },
    { key: 'nteLaborHours', label: 'NTE Labor Hrs', type: 'number', editable: true, validatorOrOpts: [Validators.required] },
    { key: 'negotiatedLaborRate', label: 'Neg. Labor Rate', type: 'dynamic', editable: true, validatorOrOpts: [Validators.required] },
    { key: 'nteMaterialCost', label: 'NTE Material $', type: 'dynamic', editable: true, validatorOrOpts: [Validators.required] },
    { key: 'nteTransportationCost', label: 'NTE Trans. $', type: 'dynamic', editable: true, validatorOrOpts: [Validators.required] },
  ];
  addRowInitialObject = {
    copaNumber: "",
    copaDescription: "",
    projIdPrefix: "",
    laborTaskCode: "",
    travelLaborTaskCode: "",
    wxDelayLaborTaskCode: "",
    travelPurchaseTaskCode: "",
    materialPurchaseTaskCode: "",
    nteLaborHours: null,
    negotiatedLaborRate: null,
    nteMaterialCost: null,
    nteTransportationCost: null

  }

  //***************************
  // Variables
  //***************************

  //***************************
  // Methods
  //***************************
  public handleRowAdd(update: TableRowUpdate): void {
    var newRowCopas: AccCopas = update.newRow as AccCopas;
    const copas = new AccCopas();
    copas.copaId = 0;
    copas.copaNumber = newRowCopas.copaNumber;
    copas.copaDescription = newRowCopas.copaDescription;
    copas.projIdPrefix = newRowCopas.projIdPrefix;
    copas.laborTaskCode = newRowCopas.laborTaskCode;
    copas.travelLaborTaskCode = newRowCopas.travelLaborTaskCode;
    copas.wxDelayLaborTaskCode = newRowCopas.wxDelayLaborTaskCode;
    copas.travelPurchaseTaskCode = newRowCopas.travelPurchaseTaskCode;
    copas.materialPurchaseTaskCode = newRowCopas.materialPurchaseTaskCode;
    copas.nteLaborHours = newRowCopas.nteLaborHours;
    copas.negotiatedLaborRate = newRowCopas.negotiatedLaborRate;
    copas.nteMaterialCost = newRowCopas.nteMaterialCost;
    copas.nteTransportationCost = newRowCopas.nteTransportationCost;
    this.mainGridService.add(copas).subscribe(update.handleSubscribe())
  }

  public handleRowUpdate(update: TableRowUpdate): void {
    this.mainGridService.update(update.newRow, update.index).subscribe(update.handleSubscribe());
  }

  //***************************
  // Init
  //***************************
  ngOnInit(): void {
  }

}
